import React from "react";
import { CONTACT } from "../data/site";

const query = encodeURIComponent(CONTACT.address);
const SRC = `https://www.google.com/maps?q=${query}&z=15&output=embed`;

export const MapEmbed = ({ height = "420px", rounded = true }) => {
  return (
    <div
      data-testid="map-embed"
      className={`relative overflow-hidden border border-white/10 ${rounded ? "rounded-3xl" : ""}`}
      style={{ height }}
    >
      <iframe
        title="ATS IT Solutions office location — Bulandshahr, UP, India"
        src={SRC}
        width="100%"
        height="100%"
        style={{ border: 0, filter: "grayscale(0.5) invert(0.92) hue-rotate(180deg) contrast(0.9)" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
      <div className="absolute bottom-4 left-4 glass rounded-xl px-4 py-2 pointer-events-none">
        <p className="font-mono text-xs text-slate-300">Bulandshahr, Uttar Pradesh</p>
      </div>
    </div>
  );
};

export default MapEmbed;
